export default "__VITE_ASSET__DUavH5A$__"